import CheckPermission from '../../../hooks/CheckPermission';
import React from 'react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { FaCheckDouble, FaHandHoldingUsd } from 'react-icons/fa';
import ReusableModal from '../../../shared/ReuseableModal';
import TextInput from '../../../shared/TextInput';
import CustomButton from '../../../shared/CustomButton';
import { RiDiscountPercentLine } from 'react-icons/ri';
import { getDepartmentDiscountLimit } from '../../../utils/businessLevelAccess';
import { useSelector } from 'react-redux';

const ApplyDiscountModal = ({
  isVisible,
  onClose,
  formikRef,
  setInvoiceDiscount,
  invoiceDiscount,
  departmentId,
}) => {
  const { t } = useTranslation();
  const { hasPermission } = CheckPermission();
  const { user, discountSettings } = useSelector(state => state?.auth);
  const currentItems = formikRef?.current?.values?.items || [];
  const itemLimits = currentItems.map(item => getDepartmentDiscountLimit(user, item?.department_id || departmentId, discountSettings));
  const maxDiscount = itemLimits.length ? Math.min(...itemLimits) : getDepartmentDiscountLimit(user, null, discountSettings);

  const handleSubmit = (values) => {
    if (!hasPermission('billing', 'update')) return;
    const discountPercentage = Number(values.discount_percentage) || 0;
    
    if (discountPercentage < 0 || discountPercentage > maxDiscount) {
      toast.error(t('Discount must be between 0 and {{max}}', { max: maxDiscount }));
      return;
    }
    
    if (currentItems.length === 0) {
      toast.error(t('No items to apply discount'));
      return;
    }
    
    const updatedItems = currentItems.map(item => {
      return {
        ...item,
        discount_type: "percentage",
        discount_amount: discountPercentage
      };
    });
    
    formikRef?.current?.setFieldValue('items', updatedItems);
    setInvoiceDiscount(discountPercentage);
    onClose()
  };

  return (
    <ReusableModal
      isVisible={isVisible}
      title={t('Apply Discount to All Items')}
      HeaderIcon={RiDiscountPercentLine}
      onClose={onClose}
      position='top'
      className='w-full md:w-[600px]'
    >
      <Formik
        initialValues={{ discount_percentage: 0 }}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div>
              <TextInput
                label={t('Discount Percentage') + ' (%)'}
                placeholder={t('Enter discount percentage')}
                name='discount_percentage'
                type='number'
                min={0}
                max={maxDiscount}
                step='any'
              />
              <div className='flex items-center justify-end gap-3 mt-4'>
                {hasPermission('billing', 'update') && (
                <CustomButton
                  type='submit'
                  label={t('Apply Discount')}
                  icon={<FaCheckDouble size={12} className='me-2' />}
                  buttonType='primary'
                />
              )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ReusableModal>
  );
};

export default ApplyDiscountModal;
